import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugLogActions } from "../helpers/debugHelper";

export const startLoadingModuleConfigsByRoleAndProcess_Step4 = (role, module) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_MODULE_CONFIG}`,
      `getByRoleAndProcess/${role}/${module}`
    );

    const body = await resp.json();
  
     debugLogActions(':: moduleConfigActions, startLoadingModuleConfigsByRoleAndProcess', { 'body': body });

    if (body.ok) {
      if (module === "TECHNOLOGY") {
        dispatch(loadingModuleConfigsTechnology(body.moduleConfigs));
      }

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const loadingModuleConfigsTechnology = (moduleConfigs) => ({
  type: types.MODULE_CONFIG_START_LOADING_BY_ROLE_PROCESS,
  payload: moduleConfigs
});